import { RootState } from '@reducers';

export const selectVehicle = (state: RootState) => state.userDashboardRouteReducer.vehicleReducer;
